import axiosInstance from './api';

export const getDashboardMetrics = async (params = {}) => {
  try {
    const response = await axiosInstance.get('/admin/dashboard-metrics', { params });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Failed to fetch dashboard metrics',
      error,
    };
  }
};
